import { render, staticRenderFns } from "./ActivityInformation.vue?vue&type=template&id=bdc191bc&scoped=true&"
import script from "./ActivityInformation.vue?vue&type=script&lang=js&"
export * from "./ActivityInformation.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInformation.vue?vue&type=style&index=0&id=bdc191bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc191bc",
  null
  
)

export default component.exports